import { i18n } from "@lingui/core";

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export async function loadMessages(locale: string) {
  const { messages } = await import(`./locales/${locale}/messages.ts`);
  i18n.load(locale, messages);
  i18n.activate(locale);
}
